import filterObjectProperties from "../../__internal__/filter-object-properties";
export const flexboxPropertyNames = ["alignItems", "alignContent", "justifyItems", "justifyContent", "flexWrap", "flexDirection", "flex", "flexGrow", "flexShrink", "flexBasis", "justifySelf", "alignSelf", "order"];
export default function filterStyledSystemFlexboxProps(originalObject) {
  return filterObjectProperties(originalObject, flexboxPropertyNames);
}